// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4a41bfb1","345":"9ffd2f53","386":"b42094ce","622":"909ece56","977":"2899dd08"}[chunkId] + ".chunk.js";
};